
export default class OperationModel {
    constructor ( 
        _WEIGHT_LB = "",
		_COST      = "",
        _TAXES     = "",
		_DISCOUNT  = "",
		_OTHER_CHARGES =  "",
		_INVOICE_READY = { name: 'No', value: 0 },
		_PERMISSIONS   = { name: 'No', value: 0 },
        _AEROTRACK = "",
        _WEIGHT_KG = "",
        _DECLARED_VALUE = "",
        _ACCOUNT = "",
        _CONSIGNEE = "",
        _COURIER_TRACKING = "",
        _LB_COST =  0,
        _AIR_WAYBILL = "",
        _CURRENT_STATUS = "",
        _CURRENT_STATUS_COMMENT = "",
        _pkg01Id = null,
        _includeTax= { name: "No", value: 0 }
    ){
      
        this.WEIGHT_LB = _WEIGHT_LB,
		this.COST      = _COST,
        this.TAXES     = _TAXES,
		this.DISCOUNT  = _DISCOUNT,
		this.INVOICE_READY = _INVOICE_READY,
		this.OTHER_CHARGES = _OTHER_CHARGES,
		this.PERMISSIONS   = _PERMISSIONS,
        this.AEROTRACK = _AEROTRACK,
        this.WEIGHT_KG = _WEIGHT_KG,
        this.DECLARED_VALUE = _DECLARED_VALUE,
        this.ACCOUNT = _ACCOUNT,
        this.CONSIGNEE = _CONSIGNEE,
        this.COURIER_TRACKING = _COURIER_TRACKING,
        this.AIR_WAYBILL = _AIR_WAYBILL,
        this.CURRENT_STATUS = _CURRENT_STATUS,
        this.CURRENT_STATUS_COMMENT = _CURRENT_STATUS_COMMENT,
        this.pkg01Id = _pkg01Id,
        this.includeTax = _includeTax,
        this.LB_COST =_LB_COST
        
   }
  
  }  
  
  